// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.8.0",
  date: "2026-08-27T12:11:58.769Z",
  gitInfo: {
    dirty: false,
    raw: "621d44bf5",
    hash: "621d44bf5",
    distance: null,
    tag: null,
    semver: null,
    suffix: "621d44bf5",
    semverString: null
  }
};
/* tslint:enable */
